module.exports = __webpack_public_path__ + "img/filters_en.457dd37.jpg";